import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import './assets/css/style.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Инициализируем авторизацию
const authStore = useAuthStore()
authStore.initializeAuth()

document.title = 'Школа Тхэквондо Юрия Азарова - Оплата'
app.mount('#app')